/**
 * Error filter configuration for Datadog RUM.
 * Each filter has a category and matching criteria.
 *
 * NOTE: Only add errors here that cannot be fixed at the source.
 * Prefer fixing the root cause over filtering errors.
 */

export type ErrorFilterCategory =
    | 'nextjs-navigation'
    | 'third-party'
    | 'browser-extensions'
    | 'deprecation-warnings';

export type ErrorFilter = {
    category: ErrorFilterCategory;
    patterns: string[];
    sourcePattern?: RegExp;
};

export const ERROR_FILTERS: ErrorFilter[] = [
    // Next.js navigation errors - transient framework-level errors during client-side navigation
    // These occur due to network issues, user navigating away, or route cancellations
    {
        category: 'nextjs-navigation',
        patterns: [
            'Failed to load static props',
            'Loading initial props cancelled',
            'Route Cancelled',
            'Cancel rendering route'
        ]
    },
    // Third-party scripts we don't control
    // Product Fruits is caught locally but may throw from other entry points
    {
        category: 'third-party',
        patterns: ['Failed to inject Product Fruits'],
        sourcePattern: /productfruits/i
    },
    // Browser extension interference - external to our codebase
    {
        category: 'browser-extensions',
        patterns: ['message channel closed before a response was received'],
        sourcePattern: /chrome-extension|moz-extension|extensions/i
    },
    // Framework deprecation warnings from unmaintained third-party libraries
    // @tippyjs/react is unmaintained - consider replacing with Radix/Headless UI
    {
        category: 'deprecation-warnings',
        patterns: ['element.ref was removed in React 19']
    }
];
